import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';

@Module({
  namespaced: true,
  name: 'section',
  store,
  dynamic: true
})
class SectionStoreModule extends VuexModule {
  public currentSectionId: string|null = null;
  public currentSectionTitle: string|null = null;
  public navigatedSectionId: string|null = null;
  public autoScrollInProgress: boolean = false;

  @Mutation
  public setCurrentSectionId(value: string|null): void {
    this.currentSectionId = value;
    this.navigatedSectionId = null;
  }

  @Mutation
  public setCurrentSectionTitle(value: string|null): void {
    this.currentSectionTitle = value;
  }

  @Mutation
  public setNavigatedSectionId(value: string|null): void {
    this.navigatedSectionId = value;
  }

  @Mutation
  public setAutoScrollInProgress(value: boolean): void {
    this.autoScrollInProgress = value;
  }
}

export default getModule(SectionStoreModule);
